const validatePassengers = ({ adults, children } = {}) => {
	// Validate that there is at least 1 adult
	const validAdults = adults > 0;

	// Validate children ages are entered
	const validChildrenAges = children?.map(age => age !== "--");

	const isValid = validAdults && validChildrenAges?.every(validAge => validAge);

	return {
		isValid,
		isValidAdults: validAdults,
		isValidChildAges: validChildrenAges
	};
};

export default validatePassengers;
export { validatePassengers };
